import React, { useEffect, useState } from "react"
import GoBack from "../subsidiary/GoBack/GoBack"
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import styles from './SMS.module.css'
import Button from '@mui/material/Button'
// import IconButton from '@mui/material/IconButton'
// import OutlinedInput from '@mui/material/OutlinedInput'
// import InputLabel from '@mui/material/InputLabel'
// import InputAdornment from '@mui/material/InputAdornment'
// import Visibility from '@mui/icons-material/Visibility'
// import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from "react-router-dom"
import {checkUser, fetchSMSToken, sendCall} from '../Login/loginSlice'

const FALLBACK_DELAY_MS = 20000

const SMS = () => {
    const phoneNumber = useSelector(state => state.loginSlice.phoneNumber)
    // const token = useSelector(state => state.loginSlice.token)
    const dispatch = useDispatch()
    const [smsCode, setSmsCode] = useState('')
    const [showFallback, setShowFallback] = useState(false)
    const [switching, setSwitching] = useState(false)
    const navigation = useNavigate()

    useEffect(() => {
        const timer = setTimeout(() => setShowFallback(true), FALLBACK_DELAY_MS)
        return () => clearTimeout(timer)
    }, [])
    // const [values, setValues] = React.useState({
    //     password: '',
    //     showPassword: false,
    // })
    const keyPress = (e) => {
        if (e.key === 'Enter') {
            handleCodeSubmit()
        }
    }
    const handleCodeChange = (e) => {
        setSmsCode(e.target.value)
    }
    const handleCodeSubmit = (e) => {

        dispatch(fetchSMSToken({ phoneNumber, smsCode })).then((params) => {
            if (!params.error) {
                window.showAlert({ title: 'Авторизация прошла успешно', type: 'success' })
                navigation('/')
                const token = params.payload.token
                dispatch(checkUser({ token }))
            }
        })
    }

    const switchToOutgoing = () => {
        if (switching) return

        if (!phoneNumber) {
            navigation('/login/outGoingCall')
            return
        }

        setSwitching(true)
        dispatch(sendCall({ phoneNumber })).then((params) => {
            setSwitching(false)
            if (!params.error) {
                navigation('/outgoingCall')
                return
            }
            const message =
                (typeof params.payload === 'string' && params.payload) ||
                params.payload?.message ||
                'Не удалось начать исходящий звонок. Попробуйте позже.'
            window.showAlert?.({ title: message, type: 'error' })
        })
    }

    return (
        <section className={'main ' + styles.loginPage}>
            <GoBack text='Назад' />
            <div className="content-wrapper">
                <div name="form" className={styles.formWrapper}>
                    <h1 className={"page-title " + styles.title}>
                        Войти <br /> в личный кабинет
                    </h1>
                    <span className={styles.input_title}>Введите последние 4 цифры номера входящего вызова</span>
                    <FormControl  required={true} className={styles.input}>
                        <TextField onKeyPress={keyPress} onChange={handleCodeChange} name="code" required={true} type='number' id={'code'} label={`Введите 4 цифры`} placeholder="****" variant="outlined" />
                    </FormControl>
                    {/* <FormControl style={{ width: '100%' }}>
                        <InputLabel htmlFor="outlined-adornment-password">Пароль</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={values.showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Password"
                        />
                    </FormControl> */}
                    <Button onClick={handleCodeSubmit} className={styles.sendBtn} variant="contained">Подтвердить</Button>
                    {showFallback && (
                        <div className={styles.fallback}>
                            <p className={styles.fallbackTitle}>Звонок не поступил?</p>
                            <p className={styles.fallbackText}>
                                Некоторые операторы не пропускают такие звонки. Войдите исходящим звонком — номер откроется сразу, позвоните на него и вход выполнится автоматически.
                            </p>
                            <Button
                                onClick={switchToOutgoing}
                                disabled={switching}
                                className={styles.fallbackBtn}
                                variant="outlined"
                            >
                                {switching ? 'Получаем номер…' : 'Войти при помощи исходящего звонка'}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </section >
    )
}
export default SMS
